// DataTable.js
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Table, Button, Divider, Spin, message, Modal, Form, Upload, Input, Select, Image, Space, Popconfirm, Tooltip } from 'antd';
import APIUtils from '../../api/APIUtils';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import constants from '../../constants/constants';
import { CommonContext } from '../../Context';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';

const ChatBotConfigure = () => {
    const { Option } = Select;
    const commonContext=useContext(CommonContext);
    const buyerId = commonContext.common.buyerId;
    const [Loading,setLoading]=useState(false);
    const [NewModalOpen,setNewModalOpen]=useState(false);
    const [updateRecord,setUpdateRecord]=useState(false);
    const [data,setData]=useState([]);
    const [form] = Form.useForm();
    const [typeValue, setTypeValue] = useState('url');
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: constants.pageSize,
      total: 0,
    });
    const [sorter, setSorter] = useState({
      field: 'CreatedOn',
      order: 'descend',
    });

    const columns = [
      {
        title: 'Name',
        dataIndex: 'domainDataName',
        key: 'domainDataName',
        sorter: true
      },
      {
        title: 'URL',
        dataIndex: 'domainDataURL',
        key: 'domainDataURL',
        sorter: true
      },
      {
        title: 'Type',
        dataIndex: 'domainDataType',
        key: 'domainDataType',
        sorter: true
      },
      {
        title: 'Data',
        dataIndex: 'domainDataText',
        key: 'domainDataText',
      },
      {
        title: 'Actions',
        key: 'actions',
        align: 'center',
        render: (text, record) => (
          <Space>
            <Button type="primary" size='small' onClick={() => handleUpdate(record)}>
              Update
            </Button>
            <Popconfirm
              title="Are you sure to delete this record?"
              onConfirm={ () => handleDelete(record.id)}
              okText="Yes"
              cancelText="No"
            >
                <Button type="primary" danger size='small'>
                Delete
              </Button>
            </Popconfirm>
          </Space>
        ),
      },
    ];
    const handleUpdate = (record) => {
      setUpdateRecord(record);
      setNewModalOpen(true);
      setTypeValue(record?.domainDataType);
      form.setFieldsValue({
        type:record?.domainDataType,
        name: record?.domainDataName,
        url: record?.domainDataURL,
        indexedData: record?.domainDataText,
      })
    };
    const handleDelete = async(id) => {
          setLoading(true);
          const response = await APIUtils.apiCall('DELETE',WebLinks.DeleteChatBotConfig+id,null,true,false);
          if(!response.isCatch && response.resultObj.statusCode==="2000"){
             getData();
             message.success(response?.resultObj?.message || "Deleted record successfully");
          }else{
              message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
          }
          setLoading(false);
    };
    const getData = async()=>{
        setLoading(true);
        let desc = sorter.order === 'descend' ? "true" : "false";
        const response = await APIUtils.apiCall('GET',WebLinks.GetChatBotConfigure+"buyerId="+buyerId+"&limit="+pagination.pageSize+"&pageNo="+pagination.current+"&orderBy="+sorter?.field +"&sortDesc="+desc,null,true,false);
        if(!response.isCatch && response.resultObj.statusCode==="2000"){
            setData(response?.resultObj?.data);
            setPagination((prev) => ({
              ...prev,
              total: response?.resultObj?.getCount || 0,
            }));
        }else{
            setData([]);
        }
        setLoading(false);
    };
    const handleCancel = () => {
        form.resetFields();
        setNewModalOpen(false);
        if(updateRecord){
          setUpdateRecord(null);
        }
        setTypeValue('url');
    };
    const onFinish = async (values) => {
      saveConfig(values);
    };
    const saveConfig=async (values)=>{
      let payload;
      payload={
        id:updateRecord?updateRecord.id:0,
        domainDataName:values.name,
        domainDataType:values.type||'url',
        domainDataURL:values?.url,
        domainDataText:values?.indexedData,
        buyerId:buyerId
      }
      const response = await APIUtils.apiCall(updateRecord?'PUT':'POST', updateRecord?WebLinks.UpdateChatBotConfig:WebLinks.AddChatBotConfig,JSON.stringify(payload));
        if (!response.isCatch && response.resultObj.statusCode === "2000") {
          message.success(response.resultObj.message)
          handleCancel();
          getData();
        }
        else{
          message.error(response.resultObj.message)
        }
    }
    const handleTableChange = (pagination, filters, sorter) => {
      setPagination(pagination);
      if(sorter?.field!==undefined){
        setSorter(sorter);
      }
    };

    useEffect(()=>{
        getData();
    },[pagination.current, pagination.pageSize, sorter.field, sorter.order]);
    useEffect(() => {
      trackPageAccess(buyerId,window.location.href)
    }, []);
  return(
    <div>
        <Spin spinning={Loading}>
            <div className='flex flex-wrap justify-between items-center'>
                <div className='uppercase font-bold text-xl'>Chat Bot Domain Configuration</div>
                <div>
                    <Button type="primary" style={{ marginRight: '10px' }} onClick={async () => {
                        setNewModalOpen(true);
                    }}>
                        Add New
                    </Button>
                </div>
            </div>
            <Divider className='my-3' />
            <Table scroll={{ x: '1000' }} sortDirections={['descend', 'ascend', 'descend']} columns={columns} dataSource={data} pagination={pagination} onChange={handleTableChange}/>
            {/* AddNew */}
            <Modal
              title={updateRecord?"Edit Chat Bot Configuration":"Add New Chat Bot Configuration"}
              open={NewModalOpen}
              onCancel={handleCancel}
              okText={<span className="capitalize">Save</span>}
              onOk={() => form.submit()}
              style={{ top: 20 }}
              width={800}
            >
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                      name="type"
                      label="Type"
                    >  
                      <Select placeholder="Select an option" onChange={(e)=>setTypeValue(e)} defaultValue={"url"}>
                        <Option value="url">URL</Option>
                        <Option value="text">Text</Option>
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="name"
                      label="Name"
                      rules={[
                          {
                          required: true,
                          message: "Required field",
                          },
                      ]}
                    >
                        <Input/>
                    </Form.Item>
                    {typeValue==="url"?
                    <Form.Item
                      name="url"
                      label="URL"
                      rules={[
                          {
                          required: true,
                          message: "Required field",
                          },
                          {
                            type: 'url',
                            message: 'Please enter a valid URL (e.g., https://example.com)',
                          }
                      ]}
                    >
                        <Input/>
                    </Form.Item>:
                    <Form.Item
                        name="indexedData"
                        label="Current indexed data for Chat Bot"
                        rules={[
                            {
                            required: true,
                            message: "Required field",
                            },
                        ]}
                    >
                        <Input.TextArea rows={20}/>
                    </Form.Item>
                  }
                </Form>
            </Modal>
        </Spin>
  </div>
    );
};

export default ChatBotConfigure;
